// @ts-nocheck
import { createSelector } from 'reselect';

export const getSessionStore = store => store.session;

export const getCurrentSession = createSelector([getSessionStore], moduleStore => moduleStore.currentSession);
